import React from "react";
import { ReadingProgress } from "./components/ReadingProgress";
import { ActivityPopup } from "./components/ActivityPopup";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { SocialStrip } from "./components/SocialStrip";
import { Transformation } from "./components/Transformation";
import { TestimonialCard } from "./components/TestimonialCard";
import { Identification } from "./components/Identification";
import { EmotionalHit } from "./components/EmotionalHit";
import { Presentation } from "./components/Presentation";
import { Tomos } from "./components/Tomos";
import { PreviewGallery } from "./components/PreviewGallery";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { testimonials } from "./components/data";
export function App() {
  return <div className="w-full overflow-x-hidden bg-white text-[var(--ink)]" data-id="element-0" data-mp="3ihv22ef0kliv">
      <MetaPixel data-id="element-1" data-mp="3mk84otygs3bf" />
      <ReadingProgress data-id="element-2" data-mp="3mjq45l4rr2xp" />
      <ActivityPopup data-id="element-3" data-mp="3rc9e8848zfxr" />

      <main className="w-full text-center" data-id="element-4" data-mp="3rbrcivytg9ig">
        <Hero data-id="element-5" data-mp="3rd19tixuhdo1" />
        <SocialStrip data-id="element-6" data-mp="3reltgdimfc74" />

        <Transformation data-id="element-7" data-mp="5orv1p50w72" />
        <TestimonialCard t={testimonials[0]} data-id="element-8" data-mp="4wupmfw6qeo" />

        <Identification data-id="element-9" data-mp="7suzhf7pr6a" />
        <EmotionalHit data-id="element-10" data-mp="2zld43f9knpe6" />
        <TestimonialCard t={testimonials[1]} data-id="element-11" data-mp="2zm4wkh7vh708" />

        <Presentation data-id="element-12" data-mp="2zng0ch1bierc" />
        <Tomos data-id="element-13" data-mp="33mf623uvifju" />
        <TestimonialCard t={testimonials[2]} data-id="element-14" data-mp="33lx02fiesmyq" />

        <PreviewGallery data-id="element-15" data-mp="33orjc3pos1qk" />
        <Bonuses data-id="element-16" data-mp="38m1gy6n8bjph" />

        <Offer data-id="element-17" data-mp="38li8dgjgy7o4" />
        <Guarantee data-id="element-18" data-mp="38l03xwmnkn54" />
        <TestimonialCard t={testimonials[3]} data-id="element-19" data-mp="38kgk2adfzoog" />

        <FAQ data-id="element-20" data-mp="3dle2mo2d6kqh" />
        <FinalCTA data-id="element-21" data-mp="3dl4jnkfqldua" />
      </main>

      <Footer data-id="element-22" data-mp="3dm5xtxs1ugg8" />
    </div>;
}